import { ClassRegisterApiFactory, TimeTableSettings } from '../../api/v2';
import { MNSproCloudApi } from '../..';

const generateApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  return ClassRegisterApiFactory(config);
};

export class TimeTableGeneralService {
  static async getTimeTableGeneralSettings(
    authToken: string,
    organizationId: string,
  ): Promise<TimeTableSettings> {
    const api = generateApi(authToken);
    const result = await api.getTimeTableSettings(organizationId);

    return result.data;
  }

  static async updateTimeTableGeneralSettings(
    authToken: string,
    organizationId: string,
    maximumTimeTableForeseeingWeeks: number,
  ): Promise<TimeTableSettings> {
    const api = generateApi(authToken);
    const result = await api.updateTimeTableSettings(organizationId, {
      maximumTimeTableForeseeingWeeks,
    });

    return result.data;
  }
}
